import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPaginationRangeProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    getControlMeasures
} from "../../../../helpers/theme/control";
import {
    formatNumber
} from "../../../../helpers/locale/format";
import {
    getPaginationRange
} from "../../util";
import Text from "../../../text";

const PaginationRange: FC<IPaginationRangeProps> = ({
    customTheme: customThemeProp,
    unitTitle,
    style
}) => {
    const context = usePaginationContext();

    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const measures = getControlMeasures({
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    });

    const range = getPaginationRange({
        totalItems: context.totalItems,
        pageSize: context.pageSize,
        page: context.page
    });

    const rangeText = `${formatNumber({
        locale: activeLocale,
        value: range.first
    })}–${formatNumber({
        locale: activeLocale,
        value: range.last
    })}`;

    const totalText = context.totalItems === undefined ? "" : ` ${localize("pagination-range-total", [
        formatNumber({
            value: context.totalItems,
            locale: activeLocale
        }),
        unitTitle ?? context.unitTitle ?? localize("pagination-unit")
    ])}`;

    return <View
        style={[
            style,
            stylesheet.container
        ]}
        aria-live="polite"
        role="status"
    >
        <Text
            customColor={colors.content.text.mid}
            variant={measures.valueVariant}
            customTheme={customTheme}
            style={stylesheet.text}
        >
            <Text
                customColor={colors.content.text.high}
                variant={measures.labelVariant}
                customTheme={customTheme}
                style={stylesheet.text}
            >
                {rangeText}
            </Text>
            {totalText}
        </Text>
    </View>;
};
export default PaginationRange;
